import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 motion-reduce:transition-none [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[#1E4FA1] text-white shadow-[0_12px_28px_rgba(30,79,161,0.22)] hover:-translate-y-0.5 hover:bg-[#153A7A] hover:shadow-[0_16px_36px_rgba(30,79,161,0.28)] motion-reduce:hover:translate-y-0",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:-translate-y-0.5 hover:bg-destructive/90 motion-reduce:hover:translate-y-0",
        outline:
          "border border-[#DDEBFA] bg-white text-[#0F172A] shadow-sm hover:-translate-y-0.5 hover:border-[#1E4FA1]/25 hover:bg-[#F7FBFF] hover:text-[#1E4FA1] motion-reduce:hover:translate-y-0",
        secondary:
          "bg-[#EBF2FA] text-[#1E4FA1] shadow-sm hover:-translate-y-0.5 hover:bg-[#DCEEFF] motion-reduce:hover:translate-y-0",
        ghost: "text-[#526274] hover:bg-[#EBF2FA] hover:text-[#1E4FA1]",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 px-3 text-xs",
        lg: "h-12 px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
